<template>

  <svg
    t="1632727442435"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="6908"
    width="64"
    height="64"
  ><path d="M512.156 925.701L151.679 566.376a41.408 41.408 0 0 1-2.258-1.927 40.688 40.688 0 0 1-5.021-5.446C39.497 449.064 38.469 271.23 142.834 166.87c100.575-100.594 260.613-107.706 369.115-20.8 108.551-86.135 268.011-79.019 367.81 20.8 106.554 106.549 107.587 280.964 2.308 388.798L512.156 925.701zM191.475 520.304l320.601 319.578L838.87 512.991c81.915-83.906 81.109-220.027-2.046-303.187-83.16-83.165-219.434-83.847-303.76-1.517l-21.309 20.805-21.215-20.904c-84.188-82.962-220.897-82.251-304.773 1.616-40.26 40.265-61.713 95.163-60.398 154.573 1.29 58.372 25.376 115.197 66.086 155.912 0.006 0.006 0.015 0.01 0.02 0.015z" p-id="6909" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconShapeEmptyHeart',
} as DefineComponent
</script>